import { FunctionComponent, useCallback } from 'react'
import { observer } from 'mobx-react-lite'
import { makeStyles, mergeClasses } from '@griffel/react'
import { Pager } from '@knowmax/pager-fluentuiv9'
import { GenericList, useGenericListSettings, PARAM_PAGE, getParamId } from '@knowmax/genericlist-core'
import { Loader } from '../core'
import { TotalItems } from '.'

const useClasses = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
})

/** Dedicated pager wrapper including loader and total number of items for lists. */
export const PagerWrapper: FunctionComponent<{ list: GenericList, className?: string }> = observer(({ list, className }) => {
  const classes = useClasses()
  const settings = useGenericListSettings()

  const goto = useCallback((page: number) => {
    const params = new URLSearchParams(settings.params)

    if (page > 1) {
      params.set(getParamId(PARAM_PAGE, list.id), page.toString())
    } else {
      params.delete(getParamId(PARAM_PAGE, list.id))
    }

    settings.serialize(params)
  }, [settings.params, list.id])

  return (
    <>
      {list.loaded && list.totalCount !== 0 &&
        <div className={mergeClasses(classes.root, className)}>
          <Pager
            pageSize={list.pageSize}
            totalResults={list.totalCount}
            currentPage={list.page}
            onChange={goto}
            display='buttons'
          />
          <div>
            {list.loading ?
              <Loader size='sm' />
              :
              <TotalItems list={list} />
            }
          </div>
        </div>
      }
    </>
  )
})